var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOfficeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.55002 12.497V10.6864L4.26969 11.9667L3.91822 12.3182C3.74249 12.4939 3.45756 12.4939 3.28183 12.3182L2.75675 12.8433L3.28183 12.3182C3.10609 12.1425 3.10609 11.8575 3.28183 11.6818L2.76232 11.1623L3.28183 11.6818L11.6818 3.2818L11.1623 2.76229L11.6818 3.2818C11.8576 3.10606 12.1425 3.10606 12.3182 3.2818L12.8486 2.75147L12.3182 3.2818L20.7182 11.6818C20.894 11.8575 20.894 12.1425 20.7182 12.3182C20.5425 12.4939 20.2576 12.4939 20.0818 12.3182L19.7304 11.9667L18.45 10.6864V12.497V20.4C18.45 20.6485 18.2486 20.85 18 20.85H15.6C15.3515 20.85 15.15 20.6485 15.15 20.4V18C15.15 16.923 14.277 16.05 13.2 16.05H10.8C9.72307 16.05 8.85002 16.923 8.85002 18V20.4C8.85002 20.6485 8.64855 20.85 8.40002 20.85H6.00002C5.7515 20.85 5.55002 20.6485 5.55002 20.4V12.497Z",
    fill: "#1C6B93",
    stroke: "#435963",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeIcon);
export default __webpack_public_path__ + "static/media/office_icon.8a80bae3e7daeade0b933f610c9bbca1.svg";
export { ForwardRef as ReactComponent };